export const NOTIFICATIONS_UPDATE_STATUS = "SOCKETS_NOTIFICATIONS_UPDATE_STATUS";
export const ADD_NEW_TICKET_LISTENER = "ADD_NEW_TICKET_LISTENER";
export const REMOVE_NEW_TICKET_LISTENER = "REMOVE_NEW_TICKET_LISTENER";